import { observer } from 'mobx-react';
import React, { useCallback, useMemo, useState } from 'react';
import { deliveryTypeStore } from '../../store/deliveryTypeStore';
import SidebarAddressList from '../SidebarAddressList/SidebarAddressList';
import SidebarBranchesList from '../SidebarBranchesList/SidebarBranchesList';
import { BRANCH_DELIVERY_TYPE, DELIVERY_TYPE } from 'src/constants/deliveryTypes';
import { appStore } from 'src/mobx/appStore';
import { branchStore } from 'src/mobx/branchStore';
import { IPickerOption } from 'src/view/components/Controls/Pickers/Picker/types';
import TabList from 'src/view/components/Tabs/TabList';
import Tabs from 'src/view/components/Tabs/Tabs';
import './style.scss';

const tabsCollection = new Map([
  [DELIVERY_TYPE.DELIVERY, { label: 'Delivery', value: DELIVERY_TYPE.DELIVERY }],
  [DELIVERY_TYPE.PICKUP, { label: 'Pickup', value: DELIVERY_TYPE.PICKUP }],
  [DELIVERY_TYPE.DINE_IN, { label: 'dine_in', value: DELIVERY_TYPE.DINE_IN }],
]);

const DeliveryTypeSidebar: React.FC = observer((): JSX.Element => {
  const [currentSelectedTab, setCurrentSelectedTab] = useState<DELIVERY_TYPE>(deliveryTypeStore.deliveryType);

  const selectTab = useCallback((tab: DELIVERY_TYPE) => {
    setCurrentSelectedTab(tab);
    deliveryTypeStore.selectDeliveryType(tab);
  }, []);

  const deliveryEnabled = useMemo((): boolean => {
    if (!appStore.settings?.delivery_type) return false;
    return [BRANCH_DELIVERY_TYPE.BOTH, BRANCH_DELIVERY_TYPE.DELIVERY].includes(appStore.settings.delivery_type as BRANCH_DELIVERY_TYPE);
  }, [appStore.settings?.delivery_type]);

  const pickupEnabled = useMemo((): boolean => {
    if (!appStore.settings?.delivery_type) return false;
    return [BRANCH_DELIVERY_TYPE.BOTH, BRANCH_DELIVERY_TYPE.PICKUP].includes(appStore.settings.delivery_type as BRANCH_DELIVERY_TYPE);
  }, [appStore.settings?.delivery_type]);

  const dineInEnabled = useMemo((): boolean => {
    return Boolean(appStore.settings?.is_emenu && branchStore.branches.some((branch) => branch.is_emenu && branch.status));
  }, [appStore.settings?.is_emenu, branchStore.branches]);

  const sidebarTabs = useMemo((): IPickerOption[] => {
    const tabs: IPickerOption[] = [];

    if (deliveryEnabled) tabs.push(tabsCollection.get(DELIVERY_TYPE.DELIVERY)!);
    if (pickupEnabled) tabs.push(tabsCollection.get(DELIVERY_TYPE.PICKUP)!);
    if (dineInEnabled) tabs.push(tabsCollection.get(DELIVERY_TYPE.DINE_IN)!);

    return tabs;
  }, [deliveryEnabled, pickupEnabled, dineInEnabled]);

  return (
    <div className="delivery-sidebar border-mainblue">
      <div className="d-flex full-height flex-column">
        {/* tabs */}
        <Tabs onChange={selectTab} options={sidebarTabs} value={currentSelectedTab} />
        {/* tabs content */}
        <div className="delivery-sidebar-content">
          <TabList tabs={sidebarTabs.map((type) => type.value as string)} className="full-height" value={currentSelectedTab}>
            {/* delivery address list */}
            {deliveryEnabled ? <SidebarAddressList /> : null}
            {/* pickup branches list */}
            {pickupEnabled ? <SidebarBranchesList /> : null}
            {/* dine-in branches list */}
            {dineInEnabled ? <SidebarBranchesList /> : null}
          </TabList>
        </div>
      </div>
    </div>
  );
});

export default DeliveryTypeSidebar;
